export const downloadImage = ({imageUrl, imageName}) => {
    fetch(imageUrl, {
        method: 'GET',
        headers: {},
    })
        .then((response) => response.blob())
        .then((blob) => {
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', imageName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        })
        .catch((err) => console.error('Image download failed:', err));
};